export default __webpack_public_path__ + "assets/audios/c9166c8e70b52439ec89e7e69ecfe5e3.mp3";